<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch3">
<div class="chapterHead">
<p class="centerImage0"><img alt="image" src="images/ch3.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-3">You sit down in an orange plastic chair. But Sam doesn’t. He starts roaming around the waiting room.</a></p><a id="pg-3">
<p class="para" style="text-indent: 5%;">“So what movie is your mom going to take us to?” Sam asks.</p>
<p class="para" style="text-indent: 5%;">You shrug. “Who knows? But remember, Sam — we promised my mom we wouldn’t act <em class="italic">too</em> wild here,” you warn with a grin.</p>
<p class="para" style="text-indent: 5%;">“Yeah, yeah,” he says. Like he really cares. He wanders over to the receptionist’s desk. He picks up a glass of clear liquid that’s sitting there.</p>
<p class="para" style="text-indent: 5%;">It’s probably just water, but …</p>
<p class="para" style="text-indent: 5%;">“Hey!” you cry. “Don’t drink that!”</p>
<p class="para" style="text-indent: 5%;">But before you can stop him, he drinks it down. Sam drains the glass in one gulp.</p>
<p class="para" style="text-indent: 5%;">Then he whirls around to face you.</p>
<p class="para" style="text-indent: 5%;">“Sam! I mean it!” you moan. “We can’t fool around. This is a <em class="italic">science</em> lab.”</p>
<p class="para" style="text-indent: 5%;">He starts to answer, but suddenly his face turns white. He clutches his throat and gasps. Then the veins on his neck start to pop out. A moment later, he makes a hideous face — as if he’s turning into Dr. Jekyll and Mr. Hyde.</p>
<p class="para" style="text-indent: 5%;">You freeze. Your heart pounds wildly.</p>
<p class="para" style="text-indent: 5%;">“What did you drink?” you ask him.</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-3"><em class="italic">Go on to</em> </a><a href="#/e9780545841054_ch004"><em class="italic">PAGE 4</em></a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841054_ch003.vue?b089ae64